export default __webpack_public_path__ + "static/media/i_b.7d9a60e5.wav";